import React, { useEffect } from 'react';
import useZodiacStore from '../store/cmsStore/zodiacStore';


const Zodiac: React.FC = () => {
  const { sections, fetchZodiacContent } = useZodiacStore();

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchZodiacContent();
  }, [fetchZodiacContent]);

  return (
    <>

 <section className="pt-4 pb-60 bg-light zodiac_page">
 <div className="container">
     <div className="zodiac_page_top_bredcrumb mb-4">
         <a href="#" className="bck_btn"><i className="fa-solid fa-arrow-left"></i> Back </a>
         <h2>Zodiac Signs</h2>
     </div>
     <div className="card border p-4 rounded-3 mb-4">
      {sections.zodiac_header && ( 
         <div className="zodiac_title_sec">
             <h4>{sections.zodiac_header.payload.field_1.value}</h4>
             <p className="mb-0 mb-lg-3">{sections.zodiac_header.payload.field_2.value}</p>
         </div>
       )}
         <div className="row g-lg-5 g-3 g-md-4">

         {sections.zodiac_header?.loop_fields.map((zodiac, index) => (
             <div key={index} className="col-lg-6">
                 <div className="standard_zodiac_signs_item">
                     <div className="zodiac_signs_icon">
                         <img src={zodiac.image} alt="" />
                     </div>
                     <div className="zodiac_signs_info">
                         <h4>{zodiac.title}</h4>
                         <p>{zodiac.description}</p>
                     </div>
                 </div>
             </div>
            ))}
          

         </div>

     </div>
     {sections.zodiac_section_2 && ( 
     <div className="card border p-4 rounded-3 mb-4">
         <div className="zodiac_title_sec">
             <h4>{sections.zodiac_section_2.payload.field_1.value}</h4>
         </div>
         <div className="row g-lg-5 g-3">
         {sections.zodiac_section_2.loop_fields.map((zodiac, index) => (
             <div key={index} className="col-lg-6">
                 <div className="standard_zodiac_signs_item">
                     <div className="zodiac_signs_info">
                     <h4>{zodiac.title}</h4>
                     <p>{zodiac.description}</p>
                     </div>
                 </div>
             </div>
             ))}
           

         </div>

     </div>
       )}

    {sections.zodiac_section_3 && ( 
     <div className="card border p-4 rounded-3 mb-4">
         <div className="zodiac_title_sec">
             <h4>{sections.zodiac_section_3.payload.field_1.value}</h4>
         </div>
         <div className="row g-lg-5 g-3">
         {sections.zodiac_section_3.loop_fields.map((zodiac, index) => (
             <div key={index} className="col-lg-6">
                 <div className="standard_zodiac_signs_item">
                     <div className="zodiac_signs_info">
                     <h4>{zodiac.title}</h4>
                     <p>{zodiac.description}</p>
                     </div>
                 </div>
             </div>
             ))}
           

         </div>

     </div>
       )}
 {sections.zodiac_note && ( 
     <div className="card border p-4 rounded-3 mb-lg-4">
         <div className="zodiac_title_sec mb-3">
             <h4>{sections.zodiac_note.payload.field_1.value}</h4>

         </div>
         <p dangerouslySetInnerHTML={{ __html: sections.zodiac_note.payload.field_2.value }}></p>

     </div>
     )}
 </div>

</section>



    </>
  
);
};

export default Zodiac;